var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8866 3.40724L3.63407 9.67449C2.5249 10.12 2.53132 10.7387 3.43057 11.0147L7.60323 12.3163L17.2576 6.22507C17.7141 5.94732 18.1312 6.09674 17.7883 6.40107L9.9664 13.4603H9.96457L9.9664 13.4612L9.67857 17.7622C10.1002 17.7622 10.2863 17.5688 10.5228 17.3406L12.5496 15.3697L16.7653 18.4837C17.5426 18.9117 18.1009 18.6917 18.2943 17.7641L21.0617 4.72174C21.345 3.58599 20.6282 3.07174 19.8866 3.40724Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f6869d74686e8398cc1b982d9b485e7d.svg";
export { ForwardRef as ReactComponent };